import i18n from 'i18next'
import {initReactI18next} from 'react-i18next'
import bg from './locales/bg'
import en from './locales/en'

i18n.use(initReactI18next).init({
  resources: {bg: bg, en: en},
  lng: 'bg',
  fallbackLng: 'bg',
  interpolation: {escapeValue: false},
  returnNull: false
})

export default i18n
